import React from "react";
import FooterMenu from "../components/footer-menu"

export default function Footer(props) 
{
    const env = props.env;  
    const menu = props.menu;   

    return (       
        
        <div className="container-fluid">
            <div className="container">
                <section className="footer-content">
                    <FooterMenu nodes={menu} env={env} menu={menu} />
                </section>
                <section className="row">
                    <div className="col-md-12 privacy">
                        <h6>©Hometown Local 2021</h6>
                        <span> | </span>
                        <a className="front-link" href="/hometown-privacy-policy">Privacy</a>
                        <span> | </span>
                        <a className="front-link" href="/terms-and-conditions.html">Terms of Use</a> 
                    </div>
                </section>
            </div>
        </div>
    );
}